<template>
  <b-row>
    <b-col md="12">
      <component-header
        title="Bulk Promotion"
        :isLoading="loading"
        :hasSearch="true"
        :hasReload="true"
        :hasRadio="true"
        @search-query="(val) => (filter = val)"
        @reload-data="refreshAllDataItem"
        @dateRangeEmit="dateRangeInput"
        @radioChangeInputEmit="dateRangeInput"
        :radioOptions="dayRadioOption"
        createButtonText="Create Bulk Promotion"
        @create-press="$router.push({ name: 'create-promo' })"
      />
    </b-col>
    <b-col md="12">
      <b-card class="card-wrap" border-variant="info">
        <div>
          <b-table
            :dark="dark"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            :items="criteriaList"
            :fields="tenantColumns"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFilter"
            thead-class="header"
            show-empty
            :busy="loading"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot="createdAt" slot-scope="data">
              <div>{{ data.item.createdAt | formatedate }}</div>
            </template>
            <template slot="action" slot-scope="data">
              <div class="d-flex">
                <div>
                  <b-button
                    :disabled="data.item.status == 'PENDING'"
                    size="sm"
                    class="mr-2 circularIcon"
                    variant="primary"
                    @click="downloadDetails(data.item)"
                  >
                    <i class="fa fa-download"></i>
                  </b-button>
                </div>
                <div>
                  <b-button
                    size="sm"
                    class="mr-2 circularIcon"
                    variant="primary"
                    @click="viewCriteria(data.item)"
                  >
                    <i class="fa fa-eye"></i>
                  </b-button>
                </div>

                <!-- <div>
                  <b-button
                    v-if="$currentUserData.role == 'Tenant'"
                    size="sm"
                    class="mr-2 circularIcon"
                    variant="danger"
                    @click="deleteCriteria(data.item)"
                  >
                    <i class="fa fa-trash bin"></i>
                  </b-button>
                </div> -->
              </div>
            </template>
          </b-table>
        </div>
        <div style="float: right">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="filterCount"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "bulkPromotion",
  components: {
    ebButton,
    ComponentHeader,
  },
  data() {
    return {
      dateFilter: 1,
      filterCount: 0,
      loading: false,
      perPage: 10,
      currentPage: 1,
      filter: "",
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      sortBy: "createdAt",
      sortDesc: true,
      tenantColumns: [
        {
          key: "createdAt",
          label: "Date",
          sortable: true,
        },
        {
          key: "count",
          label: "Impacted Customer",
          sortable: true,
          formatter: (value) => (value === null || value === undefined ? 0 : value),
        },
        {
          key: "collectionName",
          label: "Search Entity",
        },
        {
          key: "status",
          label: "Criteria Status",
          formatter: "criteriaStatus",
          tdClass: (value) => {
            if (value === "COMPLETED") {
              return "status-green";
            } else {
              return "status-orange";
            }
          },
        },
        {
          key: "notificatonStatus",
          label: "Template Status",
          formatter: "criteriaStatus",
          tdClass: (value) => {
            if (value === "COMPLETED") {
              return "status-green";
            } else {
              return "status-orange";
            }
          },
        },
        {
          key: "apporvalStatus",
          label: "Approval Status",
          formatter: "criteriaStatus",
          tdClass: (value) => {
            if (value === "COMPLETED" || value === "APPROVED") {
              return "status-green";
            } else {
              return "status-orange";
            }
          },
        },
        {
          key: "action",
        },
      ],
      dayRadioOption: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 days",
          value: 7,
        },
        {
          text: "30 days",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getFetchListOfCriteria: "bulkNotification/GetFetchListOfCriteria",
    }),
    criteriaList() {
      let criteriaListItem = this.getFetchListOfCriteria?.filter((listItem) => {
        return listItem.category == "PROMO";
      });
      return criteriaListItem;
    },
  },
  methods: {
    dateRangeInput(e) {
      this.dateFilter = e;
      this.refreshAllDataItem();
    },
    getDateData(dateData) {
      if (dateData == 1) {
        const data = {
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        return data;
      } else {
        const data = {
          fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        if (typeof dateData === "number") {
          data.fromDate = moment()
            .subtract(dateData, "days")
            .format("YYYY-MM-DD");
          return data;
        } else if (typeof dateData === "object") {
          return dateData;
        }
        return data;
      }
    },
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    criteriaStatus(value) {
      const capitalized =
        value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      return capitalized;
    },
    downloadDetails(data) {
      if (data.status == "COMPLETED") {
        window.location = data.url;
      }
    },
    viewCriteria(data) {
      if (data.count == null) {
        this.$swal({
          title: "No data found",
          type: "error",
        });
        return;
      }
      this.$router.push({
        name: "bulkpromo",
        params: {
          id: data._id,
        },
      });
    },

    //delete not required for now

    // deleteCriteria(data) {
    //   this.$swal({
    //     title: "Delete this Criteria?",
    //     text: "Are you sure? You want to Delete this Criteria?",
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     confirmButtonText: "Yes, Delete it!",
    //   }).then((result) => {
    //     if (result.value) {
    //       let payload = { ids: [] };
    //       payload.ids.push(data._id);
    //       this.$store
    //         .dispatch("bulkNotification/deleteCriteria", payload)
    //         .then((result) => {
    //           this.$toasted.success("Criteria Deleted Successfully");
    //           this.refreshAllDataItem();
    //           this.loading = true;
    //         })
    //         .catch((err) => {
    //           // delete failed
    //         });
    //     }
    //   });
    // },

    refreshAllDataItem() {
      this.loading = true;
      let payload = {
        status: "",
        ...this.getDateData(this.dateFilter),
      };
      this.$store
        .dispatch("bulkNotification/fetchListOfCriteria", payload)
        .then((data) => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.refreshAllDataItem();
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm A");
      }
    },
  },
};
</script>
<style>
.status-orange {
  color: #ff9f47;
  font-weight: 600;
}

.status-green {
  color: #34a853;
  font-weight: 600;
}
.card-wrap {
  border-radius: 16px;
}
.circularIcon {
  height: 36px;
  width: 36px;
  border-radius: 36px;
}
</style>
